import api from '../utils/api';
import { Team, CreateTeamRequest, UpdateTeamRequest, ApiResponse } from '../types';

export const teamsApi = {
  // Get all teams
  async getTeams(): Promise<Team[]> {
    const response = await api.get<ApiResponse<{ teams: Team[] }>>('/teams');
    return response.data.data?.teams || [];
  },

  // Get team by ID
  async getTeam(id: number): Promise<Team> {
    const response = await api.get<ApiResponse<{ team: Team }>>(`/teams/${id}`);
    if (!response.data.data?.team) {
      throw new Error('Team not found');
    }
    return response.data.data.team;
  },

  // Create new team
  async createTeam(teamData: CreateTeamRequest): Promise<Team> {
    const response = await api.post<ApiResponse<{ team: Team }>>('/teams', teamData);
    if (!response.data.data?.team) {
      throw new Error('Failed to create team');
    }
    return response.data.data.team;
  },

  // Update team
  async updateTeam(id: number, updates: UpdateTeamRequest): Promise<Team> {
    const response = await api.put<ApiResponse<{ team: Team }>>(`/teams/${id}`, updates);
    if (!response.data.data?.team) {
      throw new Error('Failed to update team');
    }
    return response.data.data.team;
  },

  // Delete team
  async deleteTeam(id: number): Promise<void> {
    await api.delete(`/teams/${id}`);
  },

  // Add team member
  async addTeamMember(id: number, email: string): Promise<void> {
    await api.post(`/teams/${id}/members`, { email });
  },

  // Remove team member
  async removeTeamMember(id: number, email: string): Promise<void> {
    await api.delete(`/teams/${id}/members/${encodeURIComponent(email)}`);
  },

  // Get team member emails (for sharing)
  async getTeamMembersEmails(id: number): Promise<string[]> {
    const response = await api.get<ApiResponse<{ emails: string[] }>>(`/teams/${id}/emails`);
    return response.data.data?.emails || [];
  }
};

export default teamsApi;